import React from "react";
import { Box, Container, Link, Typography } from "@material-ui/core";

export default function ContactUs() {
  return (
    <Container maxWidth="md" style={{ paddingTop: 24, paddingBottom: 40 }}>
      <Typography variant="h4" style={{ fontWeight: 700, color: "#0F3B62" }}>
        Contact Us
      </Typography>
      <Box mt={2}>
        <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
          For support or enquiries, reach us at:
        </Typography>
        <Box mt={1}>
          <Typography variant="body1" style={{ color: "#0F3B62", fontWeight: 600 }}>
            Email:{" "}
            <Link href="mailto:amar@srshta.com" color="inherit" underline="always">
              amar@srshta.com
            </Link>
          </Typography>
          <Typography variant="body1" style={{ color: "#0F3B62", fontWeight: 600 }}>
            Support:{" "}
            <Link href="mailto:support@montestory.in" color="inherit" underline="always">
              support@montestory.in
            </Link>
          </Typography>
          <Typography variant="body1" style={{ color: "#0F3B62", fontWeight: 600 }}>
            Phone:{" "}
            <Link href="tel:+918247625893" color="inherit" underline="always">
              +91 8247625893
            </Link>
          </Typography>
          {/* <Box mt={2}>
            <Typography variant="body1" style={{ color: "#334155", lineHeight: 1.8 }}>
              <strong style={{ color: "#0F3B62" }}>Address:</strong>
              <br />
              4-9-197, St no 7, HMT Nagar, Hyderabad 500076
            </Typography>
          </Box> */}
        </Box>
      </Box>
    </Container>
  );
}

